<template>
  <div class="hb-info-section-template">
    <div class="header" @click="headerAction">
      <div>
        <span class="section-title">{{ title }}</span>
        <el-tooltip :content="tip" v-if="tip && tip.length > 0">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </div>
      <i v-if="hideRightArrow"/>
      <i v-else  class="el-icon-arrow-right"></i>
    </div>
    <div class="content-wrapper">
        <slot name="content" ></slot>
    </div>
    
    <el-divider></el-divider>
  </div>
</template>
  <script>
export default {
  name: "hb_info_section_template",
  props: ["title","hideRightArrow","tip"],
  data() {
    return {};
  },
  watch: {},
  methods: {
    headerAction() {
        this.$emit("headerClick")
    }
  },
};
</script>
<style lang="scss" scoped>
.hb-info-section-template {
  .header {
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .section-title {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
  }
  .el-divider--horizontal {
    margin: 10px 0 !important;
  }
  .content-wrapper {
    padding-left: 10px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/abroad_info_section.vue